import { type DatabaseChangeType } from '@databases/types/redux';

import { type YJSChangeHandler } from '../../types';

export const setJiraField: YJSChangeHandler<DatabaseChangeType.SET_JIRA_FIELD> = ({
  ydb,
  change
}) => {
  ydb.mutate((db) => {
    const field = db.fieldsById[change.fieldId];

    field.jiraField = change.jiraField;
  });
};
